import React from 'react';

class RatingScale extends React.Component {
  constructor(props) {
    super(props);
  }

  fillBoxColor(e, rating) {
    this.props.selectRating(rating);

    setTimeout(() => {
      const announcer = document.getElementById('rating-announcer');
      if (announcer) {
        announcer.textContent = `You selected rating ${rating}`;
      }
    }, 50);
  }

  render() {
    const ratingArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    const { ratingChosen } = this.props;
    let { colorBorder } = this;
    let { colorBox } = this;
    const ratings = ratingArr
      ? ratingArr.map((rating, rate_key) => {
          colorBorder =
            rating < 7
              ? 'rating-sq red-area'
              : rating < 9
              ? 'rating-sq yellow-area'
              : 'rating-sq green-area';
          colorBox =
            ratingChosen === '' || rating > ratingChosen
              ? 'rating-boxes default-boxes'
              : rating < 7
              ? 'rating-boxes red-boxes'
              : rating < 9
              ? 'rating-boxes yellow-boxes'
              : 'rating-boxes green-boxes';
          return (
            <span className="nps-col" key={rate_key}>
              <div className={colorBorder}>{rating}</div>
              <div
                className={colorBox}
                onClick={e => {
                  this.fillBoxColor(e, rating);
                }}
                tabIndex={0}
                role="radio" 
                aria-checked={ratingChosen === rating} 
                aria-label={rating < 7 ? `${rating} rating, unsatisfied` : ((rating >= 7 && rating <= 8) ? `${rating} rating, satisfied` : `${rating} rating, extremely satisfied`)} />
            </span>
          );
        })
      : null;

    return (
      <div className="rating-container custom-pd">
        <p className="header-txt" role="heading" aria-label='Loving Ajio?' aria-level={2}>Loving Ajio?</p>
        <div aria-label="Based on your overall shopping experience, how likely are you to recommend Ajio to friends and family?">
          Based on your overall shopping experience, how likely are you to recommend AJIO to friends
          and family?
        </div>
        <div className="feedback-nps" role="radiogroup" aria-label="Select a rating">
          {ratings}
          {/* <div className="rating-meter-text">
              Not at all likely!
              <span>Very likely</span>
            </div> */}
          <div
            id="rating-announcer"
            aria-live="assertive"
            style={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              padding: '0',
              margin: '-1px',
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
              whiteSpace: 'nowrap',
              borderWidth: '0'
            }}
          ></div>
        </div>
      </div>
    );
  }
}

export default RatingScale;
